import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.sendoras.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/og-sendora.png`;

/**
 * Drop-in SEO component for every page.
 * Uses react-helmet-async to inject head tags.
 */
export function SEO({
  title,
  description,
  canonical = "/",
  image,
  type = "website",
  noindex = false,
  schema,
  keywords,
}) {
  const fullTitle = title
    ? `${title} | Sendora`
    : "Sendora — Nigeria's #1 Bulk SMS Platform";
  const canonicalUrl = `${BASE_URL}${canonical}`;
  const ogImage = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Sendora — Nigeria's #1 Bulk SMS Platform" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Sendora" />
      <meta property="og:locale" content="en_NG" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@SendoraNg" />
      <meta name="twitter:creator" content="@SendoraNg" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content="Sendora — Nigeria's #1 Bulk SMS Platform" />

      {/* JSON-LD structured data */}
      {schema &&
        (Array.isArray(schema)
          ? schema.map((s, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(s)}
              </script>
            ))
          : <script type="application/ld+json">{JSON.stringify(schema)}</script>)}
    </Helmet>
  );
}
